// Display only. Times are measured against the SERVER's clock (generatedAtMs),
// so a browser with the wrong time does not make a crash look older or newer.

export const n0 = (v: number): string => Math.round(v).toLocaleString('en-IN');

export function perMinute(v: number): string {
  if (v >= 10) return n0(v);
  if (v >= 1) return v.toFixed(1);
  return v === 0 ? '0' : v.toFixed(2);
}

export function pct(f: number): string {
  const p = f * 100;
  if (p === 0) return '0%';
  return `${p < 10 ? p.toFixed(1) : Math.round(p)}%`;
}

export function dur(ms: number): string {
  if (ms >= 60_000) return `${(ms / 60_000).toFixed(1)} min`;
  if (ms >= 1000) return `${(ms / 1000).toFixed(1)} s`;
  return `${Math.round(ms)} ms`;
}

export function ago(atMs: number, nowMs: number): string {
  const s = Math.max(0, (nowMs - atMs) / 1000);
  if (s < 90) return `${Math.round(s)} s ago`;
  if (s < 5400) return `${Math.round(s / 60)} min ago`;
  if (s < 172_800) return `${Math.round(s / 3600)} h ago`;
  return `${Math.round(s / 86_400)} days ago`;
}

export function span(ms: number): string {
  const s = Math.max(0, ms / 1000);
  if (s < 5400) return `${Math.round(s / 60)} min`;
  if (s < 172_800) return `${Math.round(s / 3600)} h`;
  return `${(s / 86_400).toFixed(1)} days`;
}

export function clock(atMs: number): string {
  return new Date(atMs).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export const STATUS_LABEL = {
  ok: 'Healthy',
  warn: 'Needs a look',
  bad: 'Failing',
  unknown: 'Not reporting yet',
} as const;

export const CONDITION_LABEL = {
  up: 'Running',
  silent: 'Stopped reporting',
  stopped: 'Stopped cleanly',
  crashed: 'Crashed',
  lost: 'Ended without a clean stop',
} as const;

/** What each part of the system is called on the page (the alert text uses the same words). */
export const PART_LABEL: Record<string, string> = {
  api: 'API',
  worker: 'Worker',
  relay: 'Outbox relay',
  jobs: 'Scheduled jobs',
  database: 'Postgres',
  providers: 'SMS, WhatsApp and UPI providers',
  edge: 'Edge and menu pages',
};

/** How an alert's message went, in words for the person reading the page. */
export const NOTIFY_LABEL = {
  pending: 'message waiting to be sent',
  sending: 'message being sent',
  sent: 'message sent',
  failed: 'message could not be sent',
  unknown: 'message may or may not have arrived',
  none: 'no message sent: no channel is set',
} as const;

/** Provider names as people say them; anything else is shown as it is. */
export const PROVIDER_LABEL: Record<string, string> = {
  msg91: 'MSG91 (SMS)',
  gupshup: 'Gupshup (WhatsApp)',
  simulated: 'Simulated UPI provider',
};

export const OPERATION_LABEL: Record<string, string> = {
  send_otp: 'Send sign-in code',
  send_template: 'Send WhatsApp message',
  collect: 'Ask for a UPI payment',
  collect_status: 'Check a UPI payment',
  cancel: 'Cancel a UPI payment',
  refund: 'Send a refund',
  refund_status: 'Check a refund',
};
